import { render, staticRenderFns } from "./venta.vue?vue&type=template&id=1fa23188"
import script from "./venta.vue?vue&type=script&lang=js"
export * from "./venta.vue?vue&type=script&lang=js"
import style0 from "./venta.vue?vue&type=style&index=0&id=1fa23188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports